import { db } from '../../firebase';
import { sdgs, slug } from '../../data';

import { ref, query, child, orderByChild, get, limitToLast, limitToFirst } from 'firebase/database';

const fetch = (mostViewedPosts) => {
  return new Promise((y, n) => {
    get(mostViewedPosts)
      .then((snapshot) => {
        if (snapshot.exists()) {
          console.log(snapshot.val());
          let obj = snapshot.val();
          let o = [];
          Object.keys(obj).forEach((b) => {
            let y = { ...obj[b] };
            y['k'] = b;
            o.push(y);
          });
          console.log({ o });
          y({ data: o });
        } else {
          console.log('No data available');
          y({ data: null });
        }
      })
      .catch((error) => {
        //console.error(error);
        y({ data: null, error });
      });
  });
};

export const fetchFaqs = () => {
  const dbRef = ref(db);
  const mostViewedPosts = child(dbRef, `/faqs/questions`);
  return fetch(mostViewedPosts);
};
